import React from 'react';
import './Styles/MainContent.css';

const MainContent = ({pageType, designer}) => {
  return (
    
    <main>
      {pageType} page
      
    </main>
    
  );
}

export default MainContent;
